// extracted by mini-css-extract-plugin
export var closeButton = "_33-3";
export var header = "_33-0";
export var link = "_33-1";
export var retryButton = "_33-2";